/**
 * Централизованная конфигурация Supabase URL
 * Используется для получения URL хранилища и других сервисов
 */

import { SUPABASE_URL } from './supabaseConstants';

export const getSupabaseStorageUrl = (bucket, path) => {
    return `${SUPABASE_URL}/storage/v1/object/public/${bucket}/${path}`;
};



export default SUPABASE_URL;
